// src/screens/admin/VuelosGuyanaAdminPanel.jsx
// Pestaña "✈️ Vuelos Guyana" del panel de administrador -- 4 sub-secciones:
// pegar actualización (procesa con IA + tabla editable), rutas publicadas
// (activar/desactivar, cupos, equipaje), estadísticas de visitas/navegación
// y configuración (tasa BRL + margen por proveedor).
import React, { useState, useEffect } from 'react';
import { getProveedores } from '../../services/vuelosGuyanaService';
import VuelosPegarActualizacion from './VuelosPegarActualizacion';
import VuelosRutasPublicadas from './VuelosRutasPublicadas';
import VuelosConfiguracion from './VuelosConfiguracion';
import VuelosEstadisticas from './VuelosEstadisticas';
import VuelosGestores from './VuelosGestores';
import VuelosRespuestasListas from './VuelosRespuestasListas';

export default function VuelosGuyanaAdminPanel() {
  const [subTab, setSubTab] = useState('pegar');
  const [proveedores, setProveedores] = useState([]);

  const cargarProveedores = async () => setProveedores(await getProveedores());
  useEffect(() => { cargarProveedores(); }, []);

  return (
    <div>
      <div style={{ display: 'flex', background: 'var(--navy-card)', borderRadius: 10, padding: 4, marginBottom: 20, gap: 4 }}>
        {[
          { id: 'pegar', label: '📋 Pegar' },
          { id: 'rutas', label: '🗺️ Rutas' },
          { id: 'respuestas', label: '💬 Respuestas' },
          { id: 'stats', label: '📊 Stats' },
          { id: 'gestores', label: '🤝 Gestores' },
          { id: 'config', label: '⚙️ Config' },
        ].map((t) => (
          <button key={t.id} onClick={() => setSubTab(t.id)} style={{
            flex: 1, padding: '8px 0', borderRadius: 8, fontSize: 12, fontWeight: 600,
            background: subTab === t.id ? 'var(--orange)' : 'transparent',
            color: subTab === t.id ? 'white' : 'var(--muted)', transition: 'all 0.2s',
          }}>{t.label}</button>
        ))}
      </div>

      {subTab === 'pegar' && proveedores.length > 0 && <VuelosPegarActualizacion proveedores={proveedores} />}
      {subTab === 'rutas' && <VuelosRutasPublicadas />}
      {subTab === 'respuestas' && <VuelosRespuestasListas />}
      {subTab === 'stats' && <VuelosEstadisticas />}
      {subTab === 'gestores' && <VuelosGestores />}
      {subTab === 'config' && proveedores.length > 0 && <VuelosConfiguracion proveedores={proveedores} onProveedoresChanged={cargarProveedores} />}
    </div>
  );
}
